<template>
    <form name="form" id="uploadPreCuratedInstitutionForm" method="POST" enctype="multipart/form-data" v-on:submit.prevent>
        <div class="hidden-container">
            <input type="file" id="uploadPreCuratedInstitutionFile" name="file" ref="fileInput" @change="fileToBeUploaded" />
        </div>
        <div class="row page-heading mx-0">
            <div class="col-8 input module_heading">
                <span class="module_icon ic-inst"></span>
                <span class="head_txt module_type_name institution-title ace_sec_hd">Pre-Curated Institution Upload</span>
            </div>
            <div class="col-4 submit btn-container text-right">
                <button type="button" class="btn btn-primary" @click.prevent="cancel" aria-label="cancel">cancel</button>
                <button type="button" class="btn btn-primary" @click.prevent="upload" aria-label="upload" :disabled="!file">upload</button>
            </div>
        </div>
        <div>
            <b-row class="mt-5 upload-asset-section">
                <b-col cols="12" class="upload-asset-thru-csv pl-3 pr-3">
                    <div class="card">
                        <div class="heading">Upload Pre-Curated Institutions thru a CSV File</div>
                        <div class="thumbnail-section">
                            <span class="icon-csvFile"></span>
                        </div>
                        <div class="card-body text-center">
                            <template v-if="file">
                                <span style="margin-top: -15px;">Chosen File: <strong>{{ file.name }}</strong></span>
                                <button type="button" class="btn btn-primary" @click.stop="chooseFile" aria-label="change CSV file" style="bottom: 40px !important;">change CSV file</button>
                            </template>
                            <template v-else>
                                <button type="button" class="btn btn-primary" @click.stop="chooseFile" aria-label="choose CSV file">choose CSV file</button>
                            </template>
                        </div>
                        <div class="sample-csv">
                            <a href="../../help/views/sampleFiles/pre_curated_institution.csv" target="_blank" aria-label="click here to get a copy of the sample csv file.">Click here</a> to get a copy of the sample csv file.
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>

        <div class="modal_container modal_alart">
          <b-modal class="" ref="uploadErrorModal" :title="'Error Message!'" :header-bg-variant="'competency-upload-exists-modal'" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
              <div class="text-center">
                  <span v-html="errorMessage"></span>
              </div>
            <div slot="modal-header" class="header-section">
              <div class="ic ic-hd"></div>
              <div class="head_txt">Error Message!</div>
              <button type="button" class="btn_close" @click="hideUploadErrorModal" aria-label="close">
                <span class="ic-close"></span>
              </button>
            </div>
            <div slot="modal-footer" class="w-100">
                <b-button @click="hideUploadErrorModal" class="btn button-primary float-right mr-2" aria-label="no"> ok </b-button>
            </div>
          </b-modal>
        </div>

    </form>
</template>

<script>
  import _ from 'lodash'
  import Papa from 'papaparse'
  import { mapActions } from 'vuex'

  var isCsvFile = function (file) {
    var fileName = file.name
    var regEx = /(.csv)$/i
    return regEx.test(fileName)
  }

  export default {
    name: 'pre-curated-institution-upload',
    data () {
      return {
        file: undefined,
        errorMessage: '',
        headers: ['externalId', 'name', 'description', 'approvedDomains']
      }
    },

    methods: {
      ...mapActions([
        'uploadPreCuratedInstitutionCsvFile'
      ]),

      cancel () {
        return this.$router.go(-1)
      },

      chooseFile () {
        let sel = 'id=uploadPreCuratedInstitutionFile'
        $('input[type=file][' + sel + ']').click()
      },

      fileToBeUploaded (ev) {
        let files = ev.target.files || ev.dataTransfer.files
        if (!files.length) {
          return
        }
        this.file = files[0]
      },

      readCsvFileAndShowWarningIfExists () {
        let self = this
        let csvFile = this.file
        Papa.parse(csvFile, {
          delimiter: ',',
          header: true,
          skipEmptyLines: true,
          complete (results) {
            let missingHeaders = []
            let fields = (results.meta.fields.length > 0) ? _.map(results.meta.fields, (v) => { return v.toLowerCase() }) : []
            $.each(self.headers, (i, val) => {
              if (!_.includes(fields, val.toLowerCase())) {
                if (missingHeaders.length === 0) {
                  missingHeaders.push(val)
                } else {
                  missingHeaders.push(' ' + val)
                }
              }
            })
            let isHeaderMissing = (missingHeaders.length > 0)
            if (!isHeaderMissing) {
              if (results.data.length === 0) {
                self.errorMessage += 'No data found. '
              }
            } else {
              self.errorMessage += 'Headers <strong>[' + missingHeaders + ']</strong> are missing.<BR><BR>'
            }
            if (self.errorMessage.length > 0) {
              self.errorMessage += 'Please fix the error and re-upload.'
              self.$refs.uploadErrorModal.show()
            } else {
              let data = new FormData()
              data.append($('#uploadPreCuratedInstitutionFile').attr('name'), self.file, self.file.name)
              self.uploadPreCuratedInstitutionCsvFile(data).then(response => {
                self.file = undefined
                return self.$router.push({name: 'taskMonitor', params: {taskId: response.taskId}})
              })
            }
          },
          error (errors) {
            console.log('error: ', errors)
          }
        })
      },

      upload () {
        if (isCsvFile(this.file)) {
          this.readCsvFileAndShowWarningIfExists()
        } else {
          this.clearFilePath()
          this.errorMessage = 'Please Select CSV file'
          this.$refs.uploadErrorModal.show()
        }
      },

      hideUploadErrorModal () {
        this.$refs.uploadErrorModal.hide()
        this.errorMessage = ''
        this.clearFilePath()
      },

      clearFilePath () {
        const input = this.$refs.fileInput
        input.type = 'text'
        input.type = 'file'
      }
    }
  }
</script>

<style scoped>
    .hidden-container{
        visibility: hidden;
        height: 1px;
    }

    .card {
        height: 345px;
        border: 0;
        background: #f5f5f5;
        box-shadow: 2px 1px 6px 0px #b9b9b9;
        border-radius: 0;
        position:relative;
    }

    .card-body {
        margin-top: 0px;
    }
</style>



// WEBPACK FOOTER //
// src/app/institution/components/PreCuratedInstitutionUpload.vue